import {React, useState, useEffect} from 'react';
import { Grid,Box, Button,Paper, Stack,Typography} from '@mui/material';
import {Add} from '@mui/icons-material';
import { HiReceiptTax } from "react-icons/hi";
import '../../App.css'
import PTSlabsConfiguration from './PTSlabsConfiguration';
import PTSlabsTable from '../table-data/PTSlabsTable';
import Popup from '../Popup';

function ViewPTSlabs(){

const [openPopup, setOpenPopup] = useState(false);
  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  const handleCloseModal = () => {
    setOpenPopup(false);
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "30px", fontWeight: "500px"}}>
      <Paper elevation={0}>
        <Grid className="form-title" style={{marginBottom: "-60px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" color="#344D67" sx={{textAlign: "center", textDecoration: "underline", margin: 5}}>Professional Tax Slab</Typography> </Grid>
          <Grid item> <HiReceiptTax style={{marginLeft: "-30px"}} size="40px" color="#344D67"/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

            <Stack display="flex" sx={{alignItems: "flex-end" }}>
                                      <Button
                                      style={{width: "200px"}}
                                        className="form-btn"
                                        variant="outlined"
                                        color="success"
                                        onClick={() => setOpenPopup(true)}
                                        startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                                        sx={{
                                          whiteSpace: "nowrap",
                                          textTransform: "none"
                                        }}
                                      >
                                        Add Professional Tax
                                      </Button>
                                    </Stack>

            <PTSlabsTable/>




            </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PTSlabsConfiguration title="Add New PT Slab" fetch_id={9999}onCloseModal={handleCloseModal}/>
          {/*<AddEmployeeForm/>
          <EmployeeSalaryForm/>
          <LeaveDataMaster/>*/}
        </Popup>

      </Paper>
    </Box>
  )
}

export default ViewPTSlabs;
